(() => {
  'use strict';
  // Presentation only: gallery blocks never alter variants, prices or the cart.
  const mounted = new Map();
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mount(root) {
    const rail = root.querySelector('#proof-viewport');
    const track = root.querySelector('#proof-track');
    const set = root.querySelector('#proof-set');
    if (!rail || !track || !set || mounted.has(rail)) return;
    const editor = root.dataset.designMode === 'true';
    const animated = !editor && set.children.length > 1;
    let duplicate = null;
    if (animated) {
      duplicate = set.cloneNode(true);
      duplicate.removeAttribute('id');
      duplicate.setAttribute('aria-hidden', 'true');
      duplicate.setAttribute('data-gallery-clone', '');
      duplicate.inert = true;
      duplicate.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      duplicate.querySelectorAll('[data-gallery-card]').forEach(node => node.removeAttribute('data-gallery-card'));
      duplicate.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
      duplicate.querySelectorAll('img').forEach(image => image.alt = '');
      track.append(duplicate);
    }

    let visible = false, hover = false, focus = false, frame = 0;
    let last = 0, position = rail.scrollLeft, manualUntil = 0;
    const listeners = [];
    const listen = (node, name, callback, options) => {
      node.addEventListener(name, callback, options);
      listeners.push(() => node.removeEventListener(name, callback, options));
    };
    let observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, { threshold: .2 });
      observer.observe(rail);
    } else visible = true;

    function tick(time) {
      if (!root.isConnected) { destroy(); return; }
      if (time < manualUntil || hover || focus) position = rail.scrollLeft;
      if (visible && !reduce.matches && !hover && !focus && !document.hidden && time >= manualUntil) {
        position += Math.min(time - last, 60) * .024;
        const period = set.getBoundingClientRect().width + 15;
        if (period > 0 && position >= period) position -= period;
        rail.scrollLeft = position;
      }
      last = time;
      frame = requestAnimationFrame(tick);
    }
    function stop() { cancelAnimationFrame(frame); frame = 0; }
    function resume() {
      if (animated && !frame) { last = 0; frame = requestAnimationFrame(tick); }
    }
    function destroy() {
      stop();
      observer?.disconnect();
      listeners.forEach(remove => remove());
      duplicate?.remove();
      mounted.delete(rail);
    }
    listen(rail, 'pointerenter', () => hover = true);
    listen(rail, 'pointerleave', () => hover = false);
    listen(rail, 'focusin', () => focus = true);
    listen(rail, 'focusout', () => focus = false);
    ['pointerdown', 'pointerup', 'wheel', 'keydown'].forEach(name => listen(rail, name, () => {
      manualUntil = performance.now() + 3000;
    }, { passive: true }));
    root.querySelectorAll('[data-rail-direction]').forEach(button => listen(button, 'click', () => {
      manualUntil = performance.now() + 3000;
      rail.scrollBy({ left: Number(button.dataset.railDirection) * 265, behavior: reduce.matches ? 'auto' : 'smooth' });
    }));
    mounted.set(rail, { root, stop, resume, destroy });
    resume();
  }
  function init(scope = document) {
    mounted.forEach(controller => { if (!controller.root.isConnected) controller.destroy(); });
    if (scope.matches?.('[data-detalora-visual]')) mount(scope);
    scope.querySelectorAll('[data-detalora-visual]').forEach(mount);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    mounted.forEach(controller => {
      if (event.target === controller.root || event.target.contains(controller.root)) controller.destroy();
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const blockId = String(event.detail?.blockId || '');
    if (!blockId) return;
    document.querySelectorAll('[data-gallery-card]').forEach(card => {
      if (card.dataset.galleryCard === blockId && card.closest('[data-design-mode="true"]')) {
        card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
      }
    });
  });
  window.addEventListener('pagehide', () => mounted.forEach(controller => controller.stop()));
  window.addEventListener('pageshow', event => {
    if (event.persisted) mounted.forEach(controller => controller.resume());
  });
  init();
})();
